/* eslint-disable max-len */
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import block from 'bem-cn'

import { PaymentMethods, PaymentTypes } from 'services/api/PaymentApi/types/common'

import { nowPaymentsSlug, paymentNameSeparator } from 'shared/constants/payment'

import { selectIsUserAuthenticated, selectUserData } from 'features/auth/selectors'
import { selectLocaleDict } from 'features/locale/selectors'
import { getCashiersList, getCryptoCurrenciesList, getPayoutSystemList } from 'features/payment/actions'
import {
  selectCryptoCurrenciesList,
  selectGetCryptoCurrencyListCommunication,
  selectGetPayoutSystemListCommunication,
  selectPaymentState,
} from 'features/payment/selectors'

import { allowedCryptoCurrencies } from '../../data/utils'
import { ChoosePayment } from '../ChoosePayment'
import { CurrentPayment } from '../CurrentPayment'

import './Withdrawal.scss'

const b = block('withdrawal')

export const Withdrawal = () => {
  const dispatch = useDispatch()

  const isAuth = useSelector(selectIsUserAuthenticated, shallowEqual)
  const locale = useSelector(selectLocaleDict, shallowEqual).payment
  const user = useSelector(selectUserData, shallowEqual)

  const { list: systemList } = useSelector(selectPaymentState, shallowEqual).payout.systemList
  const cryptoList = useSelector(selectCryptoCurrenciesList, shallowEqual)

  const isSystemComm = useSelector(selectGetPayoutSystemListCommunication, shallowEqual)
  const isCryptoComm = useSelector(selectGetCryptoCurrencyListCommunication, shallowEqual)

  const [selectedSystem, changeSelectedSystem] = useState<string>('')

  // Убрать, когда нужно будет вернуть выбор крипты
  useEffect(() => {
    if (selectedSystem === nowPaymentsSlug) {
      changeSelectedSystem(`${nowPaymentsSlug}${paymentNameSeparator}usdttrc20`)
    }
  }, [cryptoList, selectedSystem])

  useEffect(() => {
    if (isAuth) {
      // dispatch(getCashiersList())
      dispatch(getPayoutSystemList())
      dispatch(getCryptoCurrenciesList())
    }
  }, [dispatch, isAuth])

  const onChangePaymentSystem = useCallback((value: string) => {
    changeSelectedSystem(value)
  }, [])

  const isLoading = useMemo(
    () => isSystemComm.isLoading || isCryptoComm.isLoading,
    [isCryptoComm.isLoading, isSystemComm.isLoading],
  )

  const filteredSystemList = useMemo(
    () => systemList.filter(system => (system.method === PaymentMethods.CRYPTO ? !isCryptoComm.isLoading : true)),
    [isCryptoComm.isLoading, systemList],
  )

  const filteredCryptoList = useMemo(
    () => cryptoList?.filter(item => allowedCryptoCurrencies.includes(item.currency)),
    [cryptoList],
  )

  const currentPaymentComponent = useMemo(() => {
    let component = null

    if (selectedSystem === nowPaymentsSlug) {
      component = (
        <ChoosePayment
          changeSystem={onChangePaymentSystem}
          systemList={[]}
          cryptoList={filteredCryptoList}
          locale={locale}
          isLoading={isLoading}
          selectedSystem={selectedSystem}
          isCrypto
        />
      )
    } else if (selectedSystem) {
      component = (
        <CurrentPayment
          systemList={systemList}
          user={user}
          selectedSystem={selectedSystem}
          paymentType={PaymentTypes.PAYOUT}
          changeSystem={onChangePaymentSystem}
        />
      )
    }
    return component
  }, [filteredCryptoList, isLoading, locale, onChangePaymentSystem, selectedSystem, systemList, user])

  return (
    <div className={b()}>
      {!selectedSystem ? (
        <div className={b('block-wrapper')}>
          <ChoosePayment
            changeSystem={onChangePaymentSystem}
            systemList={filteredSystemList}
            locale={locale}
            isLoading={isLoading}
          />
        </div>
      ) : (
        <div className={b('block-wrapper')}>{currentPaymentComponent}</div>
      )}
    </div>
  )
}
